import version from "config/version.json";

export default () => {
    window.campaignPackage = version;
}